/* eslint-disable no-param-reassign */
import { IDocumentModel } from '../../interfaces/models/documents.interfaces'

export function getSocietyDocuments({
  societyDocuments,
  parentId,
  fileName,
  section,
}: {
  societyDocuments: IDocumentModel[]
  parentId?: string
  fileName?: string
  section?: 'feed' | 'society' | 'board' | 'society-website' | undefined
}): IDocumentModel[] {
  if (parentId) {
    societyDocuments = societyDocuments.filter(
      (document) => document.parentId === parentId
    )
  }

  if (fileName) {
    societyDocuments = societyDocuments.filter(
      (document) => document.filename === fileName
    )
  }

  if (section) {
    societyDocuments = societyDocuments.filter(
      (document) => document.section === section
    )
  }

  return societyDocuments
}

export function getRootDocuments({
  societyDocuments,
  section,
}: {
  societyDocuments: IDocumentModel[]
  section?: 'feed' | 'society' | 'board' | 'society-website' | undefined
}): IDocumentModel[] {
  const rootIds = getSocietyDocuments({
    societyDocuments,
    parentId: undefined,
    fileName: '/',
    section,
  }).map((document) => document._id)
  const documents: IDocumentModel[] = rootIds.reduce(
    (acc: IDocumentModel[], rootId) => {
      return [
        ...acc,
        ...getSocietyDocuments({
          societyDocuments,
          parentId: rootId,
          fileName: undefined,
          section,
        }),
      ]
    },
    []
  )
  return documents
}
export function getRootDocument({
  societyDocuments,
  section,
}: {
  societyDocuments: IDocumentModel[]
  section?: 'feed' | 'society' | 'board' | 'society-website' | undefined
}): IDocumentModel | undefined {
  const rootDocuments = getSocietyDocuments({
    societyDocuments,
    parentId: undefined,
    fileName: '/',
    section,
  })
  if (rootDocuments.length > 0) {
    return rootDocuments[0]
  }
  return undefined
}

export function getChildDocuments(
  societyDocuments: IDocumentModel[],
  id: string
): IDocumentModel[] {
  return societyDocuments.filter((document) => document.parentId === id)
}

export function getAllSubDocuments(
  societyDocuments: IDocumentModel[],
  id: string
): IDocumentModel[] {
  let documents: IDocumentModel[] = []
  let idsToCheck = [id]

  while (idsToCheck.length > 0) {
    const _id = idsToCheck.pop()
    if (_id !== undefined) {
      const children = getChildDocuments(societyDocuments, _id)
      documents = [...documents, ...children]
      idsToCheck = [...idsToCheck, ...children.map((document) => document._id)]
    }
  }

  return documents
}
